// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-167By","selectedFlights":"selectedFlights-1Sjk2"};